import React, { Component } from 'react';
import {Route, BrowserRouter} from 'react-router-dom';
import './App.css';
import lang from './Lang/lang.json';
import Login from './Login/Login';
import VisualApp from './VisualApp';
import Messages from '../Containers/Messages';

class App extends Component {
  constructor(){
    super();
    this.state = {
      version: "1.0.1",
      language: "es",
      langtxt: lang,
      auth: false,
      uPer: 0,
      uID: "",
      url: "https://" + window.location.host + "/server-vs/", //"http://192.168.178.29/visualshare/server-vs/",
      tkn: false,
      tableros: false,
      vis: false,
      msg: "",
      msgtype: "",
      username: "",
      msgisOpen: false
    }
  }
  changeAuth = () => {
    this.setState({auth: false, tableros: false});
    sessionStorage.clear();
  }
  mesagePop = (type, msg, usr = "") => {
    this.setState({ msgtype: type, msg: msg, username: usr, msgisOpen: true});
    this.timeout = setTimeout(() => {
      this.setState({msgisOpen: false})
    }, 3000)
  }
  changeLang = (locale) => {
    this.setState({language: locale})
  }
  componentWillMount() {
    if(sessionStorage.tkn && (this.state.auth === false)){
      this.setState({
        auth: true, 
        tkn: sessionStorage.tkn, 
        uPer: sessionStorage.uPer,
        uID: sessionStorage.uID
      });
    }
  }

  loginTry = (usr, pass) => {
    fetch(`${this.state.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify({
        type: "Login",
        screen: "tableros-home",
        usr: usr,
        pass: pass
      })
    }).then(res => res.json()).then(usr => {
      if (usr.tkn === false) {
        this.setState({tkn: usr.tkn, auth: false});
        this.mesagePop("error", "e02");
      } else {
        this.setState({tkn: usr.tkn, auth: true, uPer: usr.uPer, uID: usr.id});
        this.mesagePop("ok", "e01", usr.usrname);
        sessionStorage.tkn = usr.tkn;
        sessionStorage.uPer = usr.uPer;
        sessionStorage.uID = usr.id;
      }
    })
  }

  readDB = (scr, get=false, date=null) => {
    let bodyCall = {};
    if (date !== null) {
      bodyCall = {
        type: "read",
        screen: scr,
        date: date,
        get: get,
        tkn: this.state.tkn
      }
    } else {
      bodyCall = {
        type: "read",
        screen: scr,
        get: get,
        tkn: this.state.tkn
      }
    } 
    fetch(`${this.state.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res.tkn === false) {
        this.setState({tkn: res.tkn, auth: false});
      } else {
        this.setState({ 
          auth: true, 
          tableros: res,
        });
      }
        
    })
  }

  readVis = (tab) => {
    let bodyCall = {};
    if (tab === undefined) {
      bodyCall = {
        type: "read",
        screen: "tab",
        tkn: this.state.tkn
      }
    } else {
      bodyCall = {
        type: "read",
        screen: "tab",
        tab: tab,
        tkn: this.state.tkn
      }
    }
    fetch(`${this.state.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res.tkn) {
        this.setState({tkn: res.tkn, auth: false});
      } else {
        this.setState({vis: res});
      } 
    })
  }

  render() {
    let language = this.state.language + "-" + this.state.language.toUpperCase();
    return (
      <BrowserRouter>
        <div className="App">
          <Route path='/' exact render={() => {
            return (
              <Login 
              lang={this.state.language} 
              langtxt={this.state.langtxt} 
              login={this.loginTry} 
              loged={this.state.auth} 
              />
            )}} />
          <Route path='/home' render={() => {
            return (
              <VisualApp 
              version={this.state.version}
              uID={this.state.uID}
              uPer={this.state.uPer}
              changeLang={this.changeLang}
              lang={this.state.language} 
              langtxt={this.state.langtxt}
              db={this.readDB} 
              loged={this.state.auth} 
              tab={this.state.tableros}
              locale={language}
              vis={this.state.vis}
              readVis={this.readVis}
              url={this.state.url}
              tkn={this.state.tkn}
              msg={this.mesagePop}
              logOut={this.changeAuth}
              />)}} />
          <Messages 
            type={this.state.msgtype} 
            msg={this.state.msg} 
            locale={this.state.language}
            username={this.state.username}
            isOpen={this.state.msgisOpen}/>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/Components/App.js